module.exports = __webpack_public_path__ + "img/p3-plane.5863b199.png";